"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEMBER_TYPES = exports.MEMBER_ICONS = void 0;

var _statics = require("./statics");

var MEMBER_ICONS = {
  T1: _statics.MemberBlack,
  T2: _statics.MemberPlatinum,
  T3: _statics.MemberGold,
  T4: _statics.MemberRed
};
exports.MEMBER_ICONS = MEMBER_ICONS;
var MEMBER_TYPES = Object.keys(MEMBER_ICONS);
exports.MEMBER_TYPES = MEMBER_TYPES;